import Vue from 'vue'

const state = {
  addresses: {}
}

const mutations = {
  FETCH (state, addresses) {
    let mapped = addresses.reduce((a, i) => {
      a[i.id] = i
      return a
    }, {})
    state.addresses = mapped
  }
}

const actions = {
  fetchAll: ({commit}) => {
    return Vue.prototype.$axios.get('addresses')
      .then(response => {
        commit('FETCH', response.data)
      })
  }
}

const getters = {
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
